import { TagIcon, ShieldIcon, CloudIcon, LockIcon, FlagIcon } from '../components/Icons';

const items = [
  { icon: TagIcon, label: 'Free in early access' },
  { icon: ShieldIcon, label: 'Passkey + MFA' },
  { icon: CloudIcon, label: 'Hosted on AWS' },
  { icon: LockIcon, label: 'Data never sold' },
  { icon: FlagIcon, label: 'Made in the USA' },
];

export default function TrustStrip(): JSX.Element {
  return (
    <section className="border-y border-border bg-surface/40">
      <div className="container-page flex flex-wrap items-center justify-center gap-3 py-6">
        {items.map(({ icon: Icon, label }) => (
          <span key={label} className="pill">
            <Icon className="h-4 w-4 text-accent" />
            {label}
          </span>
        ))}
      </div>
    </section>
  );
}
